





















































































































































































































































import {
  defineComponent,
  computed,
  ref,
  watch,
  useContext
} from '@nuxtjs/composition-api'
import BlkButton from '@/components/balko-ui/BlkButton.vue'
import BlkCard from '@/components/balko-ui/BlkCard.vue'
import BlkFallbackedImg from '@/components/BlkFallbackedImg.vue'
import BlkBadge from '@/components/BlkBadge.vue'

const stringWithDefault = {
  type: String,
  default: ''
}
const numberWithDefault = {
  type: Number,
  default: 0
}
const arrayWithDefault = {
  type: Array as () => string[],
  default: () => []
}

export default defineComponent({
  name: 'blk-offer-info',
  components: {
    BlkButton,
    BlkCard,
    BlkFallbackedImg,
    BlkBadge
  },
  props: {
    status: stringWithDefault,
    availableShares: numberWithDefault,
    offerName: stringWithDefault,
    title: stringWithDefault,
    irr: numberWithDefault,
    finalDate: stringWithDefault,
    minInvestValue: numberWithDefault,
    maxInvestValue: numberWithDefault,
    openingDate: stringWithDefault,
    amountOfQuotas: numberWithDefault,
    totalDistributed: numberWithDefault,
    totalReserved: numberWithDefault,
    totalValue: numberWithDefault,
    increment: numberWithDefault,
    id: stringWithDefault,
    img: stringWithDefault,
    imgFallback: stringWithDefault,
    allowedGroups: arrayWithDefault,
    referralCode: stringWithDefault
  },
  emits: ['openInvestmentModal'],
  computed: {
    computedOpeningTime(): String {
      const now = new Date()
      if (!this.openingDate) return ''

      const offerOpeningDate = new Date(this.openingDate + 'Z')

      if (
        now.getMonth() !== offerOpeningDate.getMonth() ||
        now.getDate() !== offerOpeningDate.getDate()
      )
        return this.openingDate

      const diffTime =
        Math.abs(offerOpeningDate.getTime() - now.getTime()) / 1000
      const hours = Math.floor(diffTime / 3600) % 24
      const mins = Math.floor(diffTime / 60) % 60

      if (hours !== 0)
        return `${hours} ${this.$t('offerWideCard.hours')} ${mins} ${this.$t(
          'offerWideCard.minutes'
        )}`
      return `${mins} ${this.$t('offerWideCard.minutes')}`
    }
  },
  setup(props: any, context: any) {
    let reactiveValue: any = ref(
      props.minInvestValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/gi, '$1.')
    )
    const store = useContext()

    const totalRaised = computed(() => ({
      value: props.totalDistributed * props.increment,
      percentage: (props.totalDistributed * 100) / props.amountOfQuotas
    }))

    const totalAvailable = computed(() => ({
      value: props.availableShares * props.increment,
      percentage: (props.availableShares * 100) / props.amountOfQuotas
    }))

    const totalSold = computed(() => ({
      value:
        props.amountOfQuotas * props.increment - totalAvailable.value.value,
      percentage: 100 - totalAvailable.value.percentage
    }))

    const isExclusiveOffer = computed(() => {
      return props.allowedGroups.includes('not-investor')
    })

    const validateValue = () => {
      if (reactiveValue.value === '') {
        reactiveValue.value = props.minInvestValue.toString()
      }
      reactiveValue.value = reactiveValue.value.replace('.', '')
      reactiveValue.value = parseInt(reactiveValue.value)
      if (reactiveValue.value < props.minInvestValue) {
        reactiveValue.value = props.minInvestValue.toString()
      }

      if (reactiveValue.value > props.maxInvestValue) {
        reactiveValue.value = props.maxInvestValue.toString()
      }

      if (reactiveValue.value % props.minInvestValue !== 0) {
        reactiveValue.value =
          Math.floor(reactiveValue.value / props.minInvestValue) *
          props.minInvestValue
      }
    }

    watch(reactiveValue, () => {
      reactiveValue.value = reactiveValue.value.toString()
      reactiveValue.value = reactiveValue.value.replace(/([^0-9:/])/gi, '')
      reactiveValue.value = reactiveValue.value
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/gi, '$1.')
    })

    const loginRedirect = () => {
      store.$auth.$storage.setUniversal(
        'redirect',
        `/offers/${store.route.value.params.id}`
      )
      store.$auth.loginWith('auth0')
    }

    return {
      totalRaised,
      totalSold,
      isExclusiveOffer,
      totalAvailable,
      reactiveValue,
      validateValue,
      loginRedirect
    }
  }
})
